export const DELETE_GROUP_POPUP_STRINGS = {
  HEADING_PREFIX: 'Do you want to delete',
  NOTE_LABEL: 'Note:',
  NOTE_TEXT:
    'If you proceed with deletion, all the data associated will get removed which cannot be undone.',
  CANCEL_BUTTON: 'Cancel',
  CONFIRM_BUTTON: 'Confirm',
};

// src/constants/notificationConstants.js

export const ALLOWED_CHANNELS = ["EMAIL", "PUSH NOTIFICATION", "BANNER"];
